import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  .MuiFormLabel-root.Mui-focused {
    color: ${({ theme }) => theme.primary.purple};
  }
  .MuiInput-underline:after {
    border-bottom: 2px solid ${({ theme }) => theme.primary.purple};
  }
  .MuiTextField-root {
    margin-right: 1em;
  }
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.primary.purple};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.text.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiTableCell-root {
    padding: 6px;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiTableCell-alignRight {
    text-align: center;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const Hr = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border: 0.5px solid ${({ theme }) => theme.neutral.gray[700]};
`;

export const Convention = styled.div`
  display: flex;
  width: 50%;
  height: auto;
  align-items: center;
  justify-content: flex-start;
  p {
    margin: 0 1em 0 0.4em;
  }
`;
export const RightSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px;
`;
